import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import api from '../../helper/util/api';
import axios from "axios";

function StarRating({ value, onChange }) {
  return (
    <div style={{ display: "flex", gap: 8, justifyContent: "center" }}>
      {[1, 2, 3, 4, 5].map((star) => (
        <button
          key={star}
          onClick={() => onChange(star)}
          style={{
            fontSize: 28,
            cursor: "pointer",
            border: "none",
            background: "transparent",
            color: star <= value ? "#f5b301" : "#cfcfcf",
          }}
          aria-label={`Rate ${star} star`}
        >
          ★
        </button>
      ))}
    </div>
  );
}

export default function ReviewPage() {
  const { token } = useParams();

  const [loading, setLoading] = useState(true);
  const [valid, setValid] = useState(false);
  const [customer, setCustomer] = useState(null);

  const [rating, setRating] = useState(0);
  const [reviewText, setReviewText] = useState("");
  const [message, setMessage] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [submitted, setSubmitted] = useState(false);

  useEffect(() => {
    const validate = async () => {
      try {
        const res = await api.get(`/review/validate/${token}`);
        console.log("Validation response:", res.data);
        setValid(res.data.valid);
        setCustomer(res.data.customer);
      } catch (err) {
        setValid(false);
      } finally {
        setLoading(false);
      }
    };
    validate();
  }, [token]);

  const handleSubmit = async () => {
    setMessage("");

    if (rating < 1) return setMessage("Please select a rating.");
    if (reviewText.trim().length < 5)
      return setMessage("Please write at least 5 characters.");

    try {
      setSubmitting(true);
      const res = await api.post(`/review/submit/${token}`, {
        rating,
        reviewText,
      });
      setMessage(res.data.message);
      setSubmitted(true);
      //setValid(false); // hide form after success
    } catch (err) {
      setMessage(
        err.response?.data?.message || "Failed to submit review. Try again."
      );
    } finally {
      setSubmitting(false);
    }
  };

  if (loading) {
    return (
      <div style={styles.pageCenter}>
        <div style={styles.card}>Loading...</div>
      </div>
    );
  }

  if (!valid) {
    return (
      <div style={styles.pageCenter}>
        <div style={styles.card}>
          <img
            src="/logo192.png"
            alt="Company Logo"
            style={{ height: 50, marginBottom: 16 }}
          />
          <h2 style={styles.title}>Review Link Not Available</h2>
          <p style={styles.subTitle}>
            This link may be expired or already used.
          </p>
          {message && <p style={styles.message}>{message}</p>}
        </div>
      </div>
    );
  }

  return (
    <div style={styles.pageCenter}>
      <div style={styles.card}>
        {
            !submitted ? (
                      <>
                          <img
                              src="/logo192.png"
                              alt="Company Logo"
                              style={{ height: 55, marginBottom: 18 }}
                          />

                          <h2 style={styles.title}>We’d love your feedback</h2>
                          <p style={styles.subTitle}>
                              Your review helps us improve our service.
                          </p>

                          {customer?.customerName && (
                              <p style={{ marginTop: 6, fontSize: 14, color: "#555" }}>
                                  Hello, <b>{customer.customerName}</b> 👋
                              </p>
                          )}

                          <div style={{ marginTop: 20 }}>
                              <p style={{ fontWeight: 600, marginBottom: 10 }}>Your Rating</p>
                              <StarRating value={rating} onChange={setRating} />
                          </div>

                          <div style={{ marginTop: 20 }}>
                              <p style={{ fontWeight: 600, marginBottom: 10 }}>Your Review</p>
                              <textarea
                                  value={reviewText}
                                  onChange={(e) => setReviewText(e.target.value)}
                                  placeholder="Write your experience..."
                                  style={styles.textarea}
                              />
                          </div>

                          {message && <p style={styles.message}>{message}</p>}

                          <button
                              onClick={handleSubmit}
                              disabled={submitting}
                              style={{
                                  ...styles.submitBtn,
                                  opacity: submitting ? 0.7 : 1,
                                  cursor: submitting ? "not-allowed" : "pointer",
                              }}
                          >
                              {submitting ? "Submitting..." : "Submit Review"}
                          </button>

                          <p style={{ marginTop: 14, fontSize: 12, color: "#777" }}>
                              This review link is valid for one submission only.
                          </p>
                      </>
            ):(
                <p style={styles.message}>{message}</p>
            )
        }
      </div>
    </div>
  );
}

const styles = {
  pageCenter: {
    minHeight: "100vh",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    padding: 18,
    background: "linear-gradient(135deg, #f4f7ff, #ffffff)",
  },
  card: {
    width: "100%",
    maxWidth: 480,
    background: "#fff",
    borderRadius: 16,
    padding: 22,
    boxShadow: "0 10px 25px rgba(0,0,0,0.08)",
    textAlign: "center",
  },
  title: {
    margin: 0,
    fontSize: 22,
    fontWeight: 700,
    color: "#222",
  },
  subTitle: {
    marginTop: 8,
    marginBottom: 0,
    fontSize: 14,
    color: "#666",
  },
  textarea: {
    width: "100%",
    height: 110,
    borderRadius: 12,
    padding: 12,
    border: "1px solid #ddd",
    fontSize: 14,
    outline: "none",
    resize: "none",
  },
  submitBtn: {
    width: "100%",
    marginTop: 18,
    padding: "12px 14px",
    borderRadius: 12,
    border: "none",
    background: "#2f6fed",
    color: "#fff",
    fontWeight: 700,
    fontSize: 15,
  },
  message: {
    marginTop: 12,
    fontSize: 14,
    color: "#0a7a2f",
    fontWeight: 600,
  },
};